export default {
	Unsubmitted: 1,
	Submitted: 2,
	Iterating: 4,
	BetweenIterations: 8
}